<template>
  <div>
    <v-modal
      :position="!screen.breakPoint.tabPort ? 'bottom' : 'top'"
      :fit-content="!screen.breakPoint.tabPort"
      :animation="!screen.breakPoint.tabPort ? 'slide-up' : 'slide-down'"
      :full="!screen.breakPoint.tabPort"
      handle-click-bg
      v-model="show"
    >
      <template #header>
        {{$t('components.ProfileStatus.title')}}
      </template>

      <div class="text--center">
        <h2 class="heading-4 text-color-error mb-1" v-if="profile.status === 'OUT_PLATFORM'">{{ $t('components.ProfileStatus.outPlatform') }}</h2>

        <div v-if="profile.status === 'NEW' || profile.status === 'CORRECTION'">
          <h2 class="heading-4 text-color-space mb-1" v-if="profile.status === 'CORRECTION'">{{ $t('components.ProfileStatus.profileInEditMode') }}</h2>
          <p v-if="profile.status === 'NEW'">{{ $t('components.ProfileStatus.fillOutTheFormDesc') }}</p>
          <p v-if="profile.status === 'CORRECTION'">{{ $t('components.ProfileStatus.partOfFuncBlockedDesc') }}</p>

          <div v-if="profile.managerComment">
            <div class="divider my-2"></div>
            <p v-html="profile.managerComment"></p>
          </div>
        </div>

        <div v-if="profile.status === 'DEACTIVATED'">
          <h2 class="heading-4 text-color-error mb-1">{{ $t('components.ProfileStatus.profileDeactivated') }}</h2>
          <p>{{ $t('components.ProfileStatus.partOfFuncBlockedDesc') }}</p>
        </div>

        <div v-if="profile.status === 'VERIFICATION'">
          <h2 class="heading-4 text-color-space mb-1">{{ $t('components.ProfileStatus.profileOnAudit') }}</h2>
          <p>{{ $t('components.ProfileStatus.partOfFuncBlockedDesc') }}</p>
          <p>{{ $t('components.ProfileStatus.waitYourPofileChecked') }}</p>
        </div>

        <div v-if="profile.status === 'READY'">
          <h2 class="heading-4 text-color-success mb-1" v-if="profile.active">{{ $t('components.ProfileStatus.theProfilePublished') }}</h2>
          <h2 class="heading-4 text-color-space mb-1" v-else>{{ $t('components.ProfileStatus.theProfileIsChecked') }}</h2>

          <p>{{ $t('components.ProfileStatus.partOfFuncBlockedDesc') }}</p>

          <div v-if="profile.managerComment">
            <div class="divider my-2"></div>
            <p v-html="profile.managerComment"></p>
          </div>
        </div>
      </div>
    </v-modal>
  </div>
</template>

<script>
import vModal from '@/ui/modals/vModal'

import screen from '@/mixins/screen'

export default {
  mixins: [screen],

  props: {
    value: {
      type: Boolean,
      default: false
    },

    profile: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  components: {
    vModal
  },

  computed: {
    show: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
